var KB = require('./kb.js');
// console.log(' Load KB Frontend app');

    jQuery(document).ready(function() {
        console.log(' ready: Load KB Frontend app');
    	KB.init();
    });

// Importing KB Frontend-App Stylesheet
import '../../css/main/helpie.scss';